import React from 'react';
import { Routes, Route, useNavigate } from "react-router-dom";
import { toast } from 'sonner';
import Expenses from './Expenses';
import AddExpenses from './AddExpenses';
import ViewExpenses from './ViewExpenses';
import EditExpenses from './EditExpenses';

const ProtectedRoute = ({ element, permission, fallbackPath = '/dashboard/expense' }) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!permission) {
      toast.warning("You don't have permission to access this page.");
      navigate(fallbackPath, { replace: true });
    }
  }, [permission, navigate, fallbackPath]);

  return permission ? element : null;
};

const MainExpenses = () => {
  const User = JSON.parse(localStorage.getItem("User") || "{}");
  const Permission = User?.userRole?.permissions?.expense || {}; // Using 'expense' permissions

  return (
    <div className='bg-gray-100 text-gray-900 px-4 dark:bg-gray-900 dark:text-white'>
      <Routes>
        <Route path='/' element={<Expenses />} />

        <Route
          path='/add-expense'
          element={<ProtectedRoute element={<AddExpenses />} permission={Permission.create} />}
        />

        <Route
          path='/view-expense'
          element={<ProtectedRoute element={<ViewExpenses />} permission={Permission.read} />}
        />

        <Route
          path='/edit-expense'
          element={<ProtectedRoute element={<EditExpenses />} permission={Permission.update} />}
        />
      </Routes>
    </div>
  );
};

export default MainExpenses;
